import cx from "classnames";
import React from "react";

import * as styles from "./GdkMiddlewareDropdown.module.css";

export type GdkMiddlewareTextBoxProps = {
  value: string;
  disabled?: boolean;
  onChange?: (value: string) => void;
};

export const GdkMiddlewareTextBox = ({ value, disabled, onChange }: GdkMiddlewareTextBoxProps) => {
  if (disabled) {
    return (
      <div className={cx(styles.textBoxWrapper, styles.disabled)}>
        <span>{value}</span>
      </div>
    );
  }

  return (
    <div className={styles.textBoxWrapper}>
      <input
        className={styles.textBox}
        type="text"
        value={value}
        onChange={e => onChange?.(e.target.value)}
      />
    </div>
  );
};
